import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import { Card } from "@mui/material";

export function AppSalesHistory({ pageData, ibSales }) {
  return (
    <>
      <VuiTypography
        color="white"
        sx={{
          fontSize: "16px",
          marginTop: "35px",
          marginBottom: "16px",
        }}
      >
        {pageData.salesHistorySeccionTitle}
      </VuiTypography>
      <Card
        sx={({ breakpoints }) => ({
          padding: "0",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          [breakpoints.down("md")]: {
            flexDirection: "column",
          },
        })}
      >
        {ibSales.map(({ key, title, value }, i) => (
          <VuiBox
            key={key}
            sx={({ breakpoints }) => ({
              [breakpoints.down("md")]: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "baseline",
                padding: "15px 0 0",
                flexWrap: "wrap",
              },
              [breakpoints.up("md")]: {
                padding: "15px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                borderLeft: i ? "1px solid #A0AEC05C" : "none",
              },
            })}
          >
            {i > 0 && (
              <VuiBox
                sx={({ breakpoints }) => ({
                  background:
                    "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 35%, rgba(255,255,255,1) 65%, rgba(255,255,255,0) 100%);",
                  height: "1px",
                  width: "100%",
                  marginBottom: "25px",
                  [breakpoints.up("md")]: {
                    display: "none",
                  },
                })}
              />
            )}
            <VuiTypography
              sx={({ breakpoints }) => ({
                fontSize: "20px",
                fontWeight: "500",
                lineHeight: "28px",
                [breakpoints.down("md")]: {
                  marginLeft: "52px",
                },
              })}
            >
              {title}
            </VuiTypography>
            <VuiTypography
              color="white"
              sx={({ breakpoints }) => ({
                fontSize: "32px",
                fontWeight: "700",
                lineHeight: "44px",
                letterSpacing: "1px",
                [breakpoints.down("md")]: {
                  marginRight: "52px",
                },
              })}
            >
              {value}
            </VuiTypography>
          </VuiBox>
        ))}
      </Card>
    </>
  );
}
